import { Autoplay, Navigation } from 'swiper';
import { swiperOnResize } from '../utils/swiperOnResize.utils.js';

let ourMissionSwiperWr = document.querySelectorAll('.our-mission-swiper-wr');
ourMissionSwiperWr.forEach((el) => {
  if (el) {
    let swiperEl = el.querySelector('.swiper');
    let nextEl = el.querySelector('.swiper-button-next');
    let prevEl = el.querySelector('.swiper-button-prev');
    let slidesCount = el.querySelectorAll('.swiper-slide').length;
    let wrapper = swiperEl.querySelector('.swiper-wrapper');

    swiperOnResize('(max-width: 1023px)', swiperEl, {
      modules: [Autoplay, Navigation],
      slidesPerView: 1.1,
      spaceBetween: 12,
      navigation: {
        nextEl: nextEl,
        prevEl: prevEl,
      },
      autoplay: {
        delay: 4000,
        disableOnInteraction: false,
        pauseOnMouseEnter: true,
      },
      breakpoints: {
        375: {
          slidesPerView: 1.2,
          spaceBetween: 14,
        },
        520: {
          slidesPerView: 1.5,
          spaceBetween: 20,
        },
        768: {
          slidesPerView: 2,
          spaceBetween: 20,
        },
      },
    });
  }
});

const valuesWrapper = document.querySelector('.our-mission__values');

if (valuesWrapper) {
  const slides = valuesWrapper.querySelectorAll('.swiper-slide');

  function activateSlidesSequentially() {
    slides.forEach((slide, index) => {
      setTimeout(() => {
        slide.classList.add('active');
      }, index * 300);
    });
  }

  const observer = new MutationObserver((mutationsList) => {
    for (let mutation of mutationsList) {
      if (
        mutation.type === 'attributes' &&
        mutation.attributeName === 'class' &&
        valuesWrapper.classList.contains('animated') &&
        window.innerWidth >= 1024
      ) {
        activateSlidesSequentially();
        observer.disconnect();
        break;
      }
    }
  });

  observer.observe(valuesWrapper, {
    attributes: true,
    attributeFilter: ['class']
  });
}
